<template>
    <div class="listmain ">
        <h1 class="firTitle">反向控制</h1>
        <h3 class="sedTitle">反向控制接口</h3>

        <highlight-code lang="javascript" v-html="">
           <span>
 //反向控制接口
OrionInverseControlManager.inverseControl(mActivity, String.valueOf(System.currentTimeMillis()), OrionAction.VOD, actionValue, null);
//反控指令定义
public class OrionAction {

    public static final String PAUSE = "0"; //暂停
    public static final String PLAY = "1"; //播放
    public static final String VOLUME = "2"; //音量调节
    public static final String VOD = "3"; //点播
    public static final String PREVIOUS = "5"; //上一首
    public static final String NEXT = "4"; //下一首
    public static final String TEXT_QUERY = "13"; //文字query
    public static final String APP_UPGRADE = "19"; //app 检测音箱升级
}
       </span>
        </highlight-code>
        <h3 class="sedTitle">获取音箱播放状态</h3>
        <highlight-code lang="javascript" v-html="">
           <span>
//注册监听
OrionSpeakerStatusManager.getInstance().registerListener(mOrionISpeakerStatusCallback);

//解注册
OrionSpeakerStatusManager.getInstance().unregisterListener(mOrionISpeakerStatusCallback);

//音箱状态处理
private OrionISpeakerStatusCallback mOrionISpeakerStatusCallback = new OrionISpeakerStatusCallback() {
        @Override
        public void onSucceed(SpeakerStatus speakerStatus) {
            //获取到音箱状态speakerStatus
            if (speakerStatus != null) {
                networkStatus = speakerStatus.isNetworOk();
            }
        }

        @Override
        public void onFailed(int code, String message) {

        }
    };

       </span>
        </highlight-code>
    </div>
</template>

<script>
    export default {
        name: ""
    };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    h1,
    h2,
    h3,
    h4,
    h5 {
        padding: 0;
        margin: 0px;
        font-weight: normal;
    }

    ul,
    li {
        list-style: none;
    }

    .listmain {
        font-size: 14px;
        line-height: 26px;
        .firTitle {
            font-size: 20px;
            color: #1e4d79;
            margin-bottom: 30px;
        }
        .sedTitle {
            font-size: 16px;
            font-weight: bold;
            padding-bottom: 10px;
            border-bottom: 1px solid #f3f3f3;
            margin-bottom: 15px;
            margin-top: 50px;
            &.fir {
                margin-top: 0px;
            }
        }
        .thirdTitle {
            margin-top: 50px;
            font-weight: bold;
            line-height: 30px;
            font-size: 16px;
        }
        .codeTitle {
            font-weight: bold;
            line-height: 26px;
        }
        pre {
            margin-top: 20px;
        }
        img {
            margin: 30px 0;
            width: 100%;
        }
        table,
        table tr th,
        table tr td {
            border: 1px solid #000;
            text-align: center;
        }
        table {
            line-height: 30px;
            width: 100%;
            border-collapse: collapse;
        }
    }

    .el-submenu .el-menu-item {
        min-width: 190px;
        background: #f5f5f5;
    }

    .el-submenu {
        min-width: 190px;
        background: #f5f5f5;
    }

    img {
        margin-top: 30px;
        margin-bottom: 30px;
    }
</style>



// WEBPACK FOOTER //
// src/components/tutor/SDK-android/Rev_control.vue